import { render, staticRenderFns } from "./RelAtendimentoPorEmpresa.vue?vue&type=template&id=77264a40"
import script from "./RelAtendimentoPorEmpresa.vue?vue&type=script&lang=js"
export * from "./RelAtendimentoPorEmpresa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports